module.exports = __webpack_public_path__ + "static/media/fold_u.b67786f1.png";